import {
	MessageBox
} from 'element-ui'
export default {
	message(text, _default, callback) {
		MessageBox.alert(text, '提示', {
			confirmButtonText: '确定',
			cancelButtonText: '取消',
			showCancelButton: _default ? true : false,
			callback: callback ? callback : loop
		});
	},
	failmessage(text, _default, callback) {
		MessageBox.alert(text, '错误', {
			confirmButtonText: '确定',
			cancelButtonText: '取消',
			showCancelButton: _default ? true : false,
			callback: callback ? callback : loop
		});
	},
	confirm(text, callback, loadcontrol) {
		MessageBox.confirm(text, '提示', {
			distinguishCancelAndClose: true,
			confirmButtonText: '确定',
			cancelButtonText: '取消',
			cancelButtonClass: 'el_botton_cancelButton', //为了对调取消和确定的位置
		}).then((res) => {
			console.log(res)
			if (callback)
				callback(res)
		}).catch(() => {
			if (loadcontrol)
				loadcontrol();
		})
	},
	calculatePrint(row, name, value) {
		console.log(name, value)
		let isemty=String(value) == '' || value == undefined;
		// if(name=='批号'){
		// 	if(row["_batchManage"]&&isemty)
		// 		isemty=true;
		// 	else isemty=false;
		// }
		// if (isemty) throw `${name}不得为空`;
		//包装数量是不改的
		row[name] = value;
		let printNum = Number(row['本次打印数量']);
		let Num = Number(row['本次打印张数']);
		let packNum = Number(row['包装数量']);
		printNum = isNaN(printNum) || printNum == Infinity ? 0 : printNum;
		Num = isNaN(Num) || Num == Infinity ? 0 : Num;
		packNum = isNaN(packNum) || packNum == Infinity ? 0 : packNum;
		if (row[name] < 0) throw `${name}不得小于0`;
		row['本次打印张数'] = Num;
		row['包装数量'] = packNum;
		row['本次打印数量'] = printNum;
		if (name == '本次打印数量' && row['本次打印数量'] > row['可打数量']) {
			row[name] = '';
			throw '本次打印数量不得大于可打数量';
		}
		// if (row['本次打印数量'] < row['包装数量']) {
		// 	row[name] = '';
		// 	throw '包装数量不得大于本次打印数量';
		// }
		// console.log({printNum,Num,packNum},Number(row['包装数量']))
		if (name == '本次打印数量' || name == '包装数量') {
			Num = Math.ceil(printNum / packNum);
			Num = isNaN(Num) || Num == Infinity ? 0 : Num;
			row['本次打印张数'] = Num;
		} else if (name == '本次打印张数') {
			printNum = Num * packNum;
			// row['本次打印数量'] = printNum;
		}
		console.log({
			printNum,
			Num,
			packNum
		})
		return {
			printNum,
			Num,
			packNum
		};
	},
	getFileByteArr({
		loadingcontrol,
		data,
		success
	}) {
		this.base.http({//导出数据为execel
			url: 'Web/reportExport',
			data,
			success,
			loadingcontrol
		});
	},
	DownFileServer({
		loadingcontrol,
		data,
		success
	}){
		this.base.http({
			url: 'Web/GetFileBaseString',
			data,
			success,
			loadingcontrol
		});
	},
	insertErrorClose({
		loadingcontrol,
		data,
		success
	}){
		this.base.http({
			url: 'Web/insertErrorClose',
			data,
			success,
			loadingcontrol
		});
	},
	DownLoadBase64({
		loadingcontrol,
		data
	}) {
		let {
			base64Str,
			name
		} = data;

		function dataURLtoBlob(dataurl) {
			var arr = dataurl.split(','),
				mime = arr[0].match(/:(.*?);/)[1],
				bstr = atob(arr[1]),
				n = bstr.length,
				u8arr = new Uint8Array(n);
			while (n--) {
				u8arr[n] = bstr.charCodeAt(n);
			}
			return new Blob([u8arr], {
				type: mime
			});
		}

		function downloadFile(url, name) {
			console.log(name)
			var a = document.createElement("a")
			a.setAttribute("href", url)
			a.setAttribute("download", name)
			a.setAttribute("target", "_blank")
			let clickEvent = document.createEvent("MouseEvents");
			clickEvent.initEvent("click", true, true);
			a.dispatchEvent(clickEvent);
		}

		function downloadFileByBase64(base64, name) {
			var myBlob = dataURLtoBlob(base64)
			var myUrl = URL.createObjectURL(myBlob)
			downloadFile(myUrl, name);
			loadingcontrol();
		}

		function getBase64Type(type) {
			switch (type) {
				case 'txt':
					return 'data:text/plain;base64,';
				case 'doc':
					return 'data:application/msword;base64,';
				case 'docx':
					return 'data:application/vnd.openxmlformats-officedocument.wordprocessingml.document;base64,';
				case 'xls':
					return 'data:application/vnd.ms-excel;base64,';
				case 'xlsx':
					return 'data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,';
				case 'pdf':
					return 'data:application/pdf;base64,';
				case 'pptx':
					return 'data:application/vnd.openxmlformats-officedocument.presentationml.presentation;base64,';
				case 'ppt':
					return 'data:application/vnd.ms-powerpoint;base64,';
				case 'png':
					return 'data:image/png;base64,';
				case 'jpg':
					return 'data:image/jpeg;base64,';
				case 'gif':
					return 'data:image/gif;base64,';
				case 'svg':
					return 'data:image/svg+xml;base64,';
				case 'ico':
					return 'data:image/x-icon;base64,';
				case 'bmp':
					return 'data:image/bmp;base64,';
			}
		}
		if (!name.includes('.'))
			name += '.xls';
		let arr=name.split('.');
		let base64url = `${getBase64Type(arr[1])}${base64Str}`;
		console.log(name)
		downloadFileByBase64(base64url, name);
	},
	checkCurrentPlat() {
		var ua = window.navigator.userAgent;
		return {
			ua: ua,
			browser: {},
			pcwx: ua.match(/WindowsWechat/),
			weixin: ua.match(/MicroMessenger\/([^\s]+)/i), //微信
			webkit: ua.match(/WebKit\/([\d.]+)/i), //webkit浏览器
			isAndroid: ua.indexOf('Android') > -1 || ua.indexOf('Adr') > -1, //安卓
			isiOS: ua.match(/\(Macintosh(.*?)Mac OS X/) || ua.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/), //苹果 or iPad
			ipod: ua.match(/(iPod).*OS\s([\d_]+)/i),
			chrome: ua.match(/CriOS\/([\d.]+)/i), //谷歌
			opera: ua.match(/Opera\/([\d.]+)/i), // 欧朋浏览器
			safari: ua.match(/Safari\/([\d.]+)/i) //苹果浏览器
		}
	}

}
